// extracted by mini-css-extract-plugin
export default {"ugc-thought":"ThoughtOfUGC_ugc-thought__vkKcm","save-box":"ThoughtOfUGC_save-box__qFrX9"};